export function getCurrentDate() {
    const today = new Date();
    const month = today.getMonth() + 1; // months are 0-based
    const day = today.getDate();
    const year = today.getFullYear();
  
    return `${month}/${day}/${year}`;
}

